export default "__VITE_ASSET__B6rZ0zqd__"